
declare const window: Window & typeof globalThis & Record<string, any>;

export const getMerchantFromSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  
  // A subdomain typically consists of the first part before the domain.
  if (parts.length >= 3) {
    return parts[0];
  } else {
    return null; // No subdomain found
  }
}

export const getInitialMerchId = () =>(
  window.voa_config?.merchantID || process.env.MERCH_ID || getMerchantFromSubdomain()
).replace("/", "");
